// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const DictionaryLanguageDto = {
    De: 'DE',
    Dk: 'DK',
    En: 'EN',
    Fr: 'FR',
    Nl: 'NL',
    No: 'NO',
    Se: 'SE',
} as const;

export type DictionaryLanguageDto = typeof DictionaryLanguageDto[keyof typeof DictionaryLanguageDto];



